/**
 * Created by pmnia on 7/1/15.
 */
(function() {
    var app = angular.module('app');
    app.config(['$stateProvider', 'DOMAIN_UI', '$locationProvider', '$ocLazyLoadProvider','$sceDelegateProvider',
        function ($stateProvider, DOMAIN_UI, $locationProvider, $ocLazyLoadProvider,$sceDelegateProvider) {

            var config = {
                docTitle: undefined,
                resolveAlways: {},
                parent:'layout'
            };
            $sceDelegateProvider.resourceUrlWhitelist([
                'self',
                'https://www.youtube.com/**',
                '*://www.youtube.com/**',
                '*://www.vimeo.com/**',
                '*://player.vimeo.com/**'

            ]);

            // with lazy loading
            $stateProvider

                //.state('pageOracle', { // when page is nor found then this state is caller
                //    //abstract:true,
                //    url: '/oracle',
                //    parent: config.parent,
                //    resolve:{
                //        fallback : /*@ngInject*/function ($q, dataservice, $state, $location){
                //            //call server to gert the
                //            //var currentStateData = {
                //            //    Name: $state.current.name,
                //            //    Params: $state.params,
                //            //    URL: $state.href($state.current.name, $state.params)
                //            //};
                //            console.log($location.absUrl());
                //            dataservice.oracle.getFallbackPage({url:$location.absUrl()})
                //                .then(function(data){
                //
                //                        //call redirection
                //                        if(data && data.page) {
                //                            $state.go(data.page, angular.extend({}, data.args));
                //                        }else{
                //                            $state.go('404', {language: 'fr'});
                //                        }
                //
                //                        return $q.reject('Error!');
                //                    }
                //                    ,function(){ // if error, we redirect to 404
                //                        $state.go('404', {language: 'fr'});
                //                        return $q.reject('Error!');
                //                    })
                //        }
                //    }
                //})

                //Association
                .state('association', {
                    url: '/a/:cId',
                    controller: 'AssociationController',
                    controllerAs: 'vm',
                    parent: config.parent,
                    title: 'association',
                    data:{
                        home: 'association',
                    },
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Association'
                    },
                    obtVid : 2,
                    obtPage: 1,
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            //var isMobile = false;
                            //var templateName = isMobile ? './association/association_mobile.html' : './association/association.html';
                            //var templateName = './association/association.html';
                            var template = require('html!./association/association.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./association/association.module.js');
                                require('./association/association.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.association'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }]
                    }
                })

                .state('therapistMaster', {
                    abstract: true,
                    url: '/t/:cId/:tId',
                    controller: 'TherapistMasterController',
                    controllerAs: 'vm',
                    parent: config.parent,
                    title: 'therapistMaster',
                    data:{
                        home: 'therapistClinic',
                    },
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./therapistMaster/therapistMaster.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./therapistMaster/therapistMaster.module.js');
                                require('./therapistMaster/therapistMaster.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.therapistMaster'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }],

                      data_footer: /*@ngInject*/function(dataservice, $stateParams){
                        return dataservice.page.getFooterContent($stateParams.cId, $stateParams.tId);
                      }
                    }
                })

                .state('clinicMaster', {
                    abstract: true,
                    url: '/c/:cId',
                    controller: 'ClinicMasterController',
                    controllerAs: 'vm',
                    parent: config.parent,
                    title: 'clinicMaster',
                    data:{
                        home: 'clinic',
                    },
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./clinicMaster/clinicMaster.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./clinicMaster/clinicMaster.module.js');
                                require('./clinicMaster/clinicMaster.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.clinicMaster'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }]
                    }
                })

                .state('therapist', {
                    parent : 'clinicMaster',
                    url: '/t/:tId',
                    controller: 'TherapistController',
                    controllerAs: 'vm',
                    title: 'therapist',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Therapist'
                    },
                    obtVid : 1,
                    obtPage: 2,
                    logoutState : 'clinic',
                    templateProvider: ['$q', function ($q) {
                      var deferred = $q.defer();
                      require.ensure([], function () {
                        var template = (DOMAIN_UI.mode == 2)
                          ? require('html!./therapist/clinic.html')
                          : require('html!./therapist/therapist.html');
                        // var template = require('html!./therapist/therapist.html');
                        deferred.resolve(template);
                      });
                      return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./therapist/therapist.module.js');
                                require('./therapist/therapist.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.therapist'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }],
                        data_profile: /*@ngInject*/function(module, dataservice, $stateParams, $state){
                            console.log('therapistConfig');
                          return dataservice.therapist.getTherapist($stateParams.cId, $stateParams.tId);

                        },
                        data_calendar: /*@ngInject*/function(module, dataservice, $stateParams){
                          return dataservice.calendar.getProfile($stateParams.cId, $stateParams.tId);
                        }
                    }
                })

                .state('clinic', {
                    parent : 'clinicMaster',
                    url: '',
                    controller: 'ClinicController',
                    controllerAs: 'vm',
                    title: 'clinic',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Clinic'
                    },
                    obtVid : 1,
                    obtPage: 1,
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./clinic/clinic.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./clinic/clinic.module.js');
                                require('./clinic/clinic.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.clinic'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }],
                        calendarProfile:/*@ngInject*/function (module, dataservice, $stateParams){
                            return dataservice.calendar.getProfile($stateParams.cId);
                        }
                    }
                })

                .state('therapistClinic', {
                    parent: 'therapistMaster',
                    url: '',
                    controller: 'TherapistController',
                    controllerAs: 'vm',
                    title: 'Therapist - Clinic',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Therapist'
                    },
                    //resolve:{
                    //    calendarProfile:getCalendarProfile
                    //},
                    obtVid: 3,
                    obtPage: 2,
                    preferenceState : 'preferenceTherapist',
                    historyState : 'historyTherapist',
                    resellerState : 'resellerBookingReportTherapist',
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./therapist/therapist.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./therapist/therapist.module.js');
                                require('./therapist/therapist.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.therapist'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }],
                        data_profile: /*@ngInject*/function(module, dataservice, $stateParams, $state){
                            console.log('therapistClinicConfig');
                          return dataservice.therapist.getTherapist($stateParams.cId, $stateParams.tId);

                        },
                        data_calendar: /*@ngInject*/function(module, dataservice, $stateParams){
                          return dataservice.calendar.getProfile($stateParams.cId, $stateParams.tId);
                        }
                    }
                })

                .state('preference', {
                    parent : 'clinicMaster',
                    url: '/p/:uId',
                    controller: 'PreferenceController',
                    controllerAs: 'vm',
                    title: 'preference',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Preference'
                    },
                    obtVid : 1,
                    obtPage: 3,
                    logoutState : 'clinic',
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./preference/preference.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./preference/preference.module.js');
                                require('./preference/preference.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.preference'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }]
                    }
                })

                .state('preferenceTherapist', {
                    parent : 'therapistMaster',
                    url: '/p/:uId',
                    controller: 'PreferenceController',
                    controllerAs: 'vm',
                    title: 'preference',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Preference'
                    },
                    obtVid : 3,
                    obtPage: 3,
                    logoutState : 'therapistClinic',
                    preferenceState : 'preferenceTherapist',
                    historyState : 'historyTherapist',
                    resellerState : 'resellerBookingReportTherapist',
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./preference/preference.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./preference/preference.module.js');
                                require('./preference/preference.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.preference'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }]
                    }
                })

                .state('history', {
                    parent : 'clinicMaster',
                    url: '/h/:uId',
                    controller: 'HistoryController',
                    controllerAs: 'vm',
                    title: 'history',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> History'
                    },
                    obtVid : 1,
                    obtPage: 3,
                    logoutState : 'clinic',
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./history/history.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./history/history.module.js');
                                require('./history/history.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.history'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }]
                    }
                })

                .state('historyTherapist', {
                    parent : 'therapistMaster',
                    url: '/h/:uId',
                    controller: 'HistoryController',
                    controllerAs: 'vm',
                    title: 'history',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> History'
                    },
                    obtVid : 3,
                    obtPage: 3,
                    logoutState : 'therapistClinic',
                    preferenceState : 'preferenceTherapist',
                    historyState : 'historyTherapist',
                    resellerState : 'resellerBookingReportTherapist',
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./history/history.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./history/history.module.js');
                                require('./history/history.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.history'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }]
                    }
                })

                .state('dynamic', {
                    parent: config.parent,
                    url: '/dynamicPage/:cId/:kId',
                    controller: 'DynamicController',
                    controllerAs: 'vm',
                    title: 'dynamic',
                    // data:{
                    //     home: '',
                    // },
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Dynamic'
                    },
                    obtVid : 1,
                    obtPage: 0,
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./dynamic/dynamic.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./dynamic/dynamic.module.js');
                                require('./dynamic/dynamic.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.dynamic'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }]
                    }
                })

                //Parent set to clinic
                .state('clinic.service', {
                    //parent: 'therapist',
                    url: '/service/:sId',
                    controller: 'ServiceController',
                    controllerAs: 'vmService',
                    title: 'service',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Service'
                    },
                    obtVid : 1,
                    obtPage: 1,
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = (DOMAIN_UI.mode == 2)
                                ? require('html!./service/service_with_banner.html')
                                : require('html!./service/service.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./service/service.module.js');
                                require('./service/service.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.service'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });
                            return deferred.promise;
                        }]
                    }
                })
                //Parent set to therapist
                .state('therapist.service', {
                    //parent: 'therapist',
                    url: '/service/:sId',
                    controller: 'ServiceController',
                    controllerAs: 'vmService',
                    title: 'service',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Service'
                    },
                    obtVid: 1,
                    obtPage: 2,
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = (DOMAIN_UI.mode == 2)
                                ? require('html!./service/service_with_banner.html')
                                : require('html!./service/service.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./service/service.module.js');
                                require('./service/service.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.service'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });
                            return deferred.promise;
                        }]
                    }
                })

                //Parent set to therapistClinic
                .state('therapistClinic.service', {
                    //parent: 'therapistClinic',
                    url: '/service/:sId',
                    controller: 'ServiceController',
                    controllerAs: 'vmService',
                    title: 'service',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Service'
                    },
                    obtVid : 3,
                    obtPage: 2,
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = (DOMAIN_UI.mode == 2)
                                ? require('html!./service/service_with_banner.html')
                                : require('html!./service/service.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./service/service.module.js');
                                require('./service/service.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.service'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });
                            return deferred.promise;
                        }]
                    }
                })

                .state('advisor_wl', {
                    parent: config.parent,
                    url: '/l/:cId/:wq/:lq',
                    controller: 'AdvisorController',
                    controllerAs: 'vm',
                    title: 'advisor',
                    data:{
                        home: 'advisor_wl',
                    },
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Advisor'
                    },
                    obtVid : 1,
                    obtPage: 0,
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./advisor/advisor.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./advisor/advisor.module.js');
                                require('./advisor/advisor.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.advisor'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }]
                    }
                })

                .state('advisor_w', {
                    parent: config.parent,
                    url: '/l/:cId/:wq',
                    controller: 'AdvisorController',
                    controllerAs: 'vm',
                    title: 'advisor',
                    data:{
                        home: 'advisor_w',
                    },
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Advisor'
                    },
                    obtVid : 1,
                    obtPage: 0,
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./advisor/advisor.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./advisor/advisor.module.js');
                                require('./advisor/advisor.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.advisor'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }]
                    }
                })

                .state('advisor', {
                    parent: config.parent,
                    url: '/l/:cId',
                    controller: 'AdvisorController',
                    controllerAs: 'vm',
                    title: 'advisor',
                    data:{
                        home: 'advisor',
                    },
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Advisor'
                    },
                    obtVid : 1,
                    obtPage: 0,
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./advisor/advisor.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./advisor/advisor.module.js');
                                require('./advisor/advisor.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.advisor'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }]
                    }
                })

                .state('formly', {
                    parent: config.parent,
                    url: '/formly/:cId/:kId',
                    controller: 'FormlyController',
                    controllerAs: 'vm',
                    title: 'formly',
                    data:{
                        home: 'formly',
                    },
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Formly'
                    },
                    obtVid : 1,
                    obtPage: 0,
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./formly/formly.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                //require('./../bower_components/apiCheck/dist/api-check.min.js');
                                //require('./../bower_components/angular-formly/dist/formly.min.js');
                                //require('./../bower_components/angular-formly-templates-bootstrap/dist/angular-formly-templates-bootstrap.min.js');
                                require('./formly/formly.module.js');
                                require('./formly/formly.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.formly'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }]
                    }
                })

                //resellers report
                .state('resellerBookingReport', {
                    parent : 'clinicMaster',
                    url: '/report/:uId',
                    controller: 'resellerBookingReportCtrl',
                    controllerAs: 'vm',
                    title: 'report',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> report'
                    },
                    obtVid : 1,
                    obtPage: 3,
                    logoutState : 'clinic',
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./resellers/reports/resellerBookingReport.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module:['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./resellers/resellers.module.js');
                                require('./resellers/reports/resellerBookingReport.controller.js');
                                require('./resellers/directives/resellerBookingReport/resellerBookingReport.directive.js');
                                $ocLazyLoad.load({
                                    name: 'app.resellers'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });
                            return deferred.promise;
                        }],
                        comboOptions : /*@ngInject*/function loadComboBox(dataservice, logger, $stateParams){
                            var options = [
                                {'id': 10, 'name': 'therapists'}
                            ];
                            var args = {cId:$stateParams.cId || null };

                            return dataservice.form.getOptions(options, {isTool:true}, args)
                                .then(function(result){
                                    if(result){
                                        return result;
                                    }else{
                                        logger.error(result.body ? result.body : 'Get combobox options failed', result);
                                        return [];
                                    }
                                });
                        }
                    }
                })

                .state('resellerBookingReportTherapist', {
                    parent : 'therapistMaster',
                    url: '/report/:uId',
                    controller: 'resellerBookingReportCtrl',
                    controllerAs: 'vm',
                    title: 'report',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> report'
                    },
                    obtVid : 3,
                    obtPage: 3,
                    logoutState : 'therapist',
                    resellerState : 'resellerBookingReportTherapist',
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./resellers/reports/resellerBookingReport.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module:['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./resellers/resellers.module.js');
                                require('./resellers/reports/resellerBookingReport.controller.js');
                                require('./resellers/directives/resellerBookingReport/resellerBookingReport.directive.js');
                                $ocLazyLoad.load({
                                    name: 'app.resellers'
                                }).then(function(){
                                    deferred.resolve(true);
                                });
                            });
                            return deferred.promise;
                        }],
                        comboOptions : /*@ngInject*/function loadComboBox(dataservice, logger, $stateParams){
                            var options = [
                                {'id': 10, 'name': 'therapists'}
                            ];
                            var args = {cId:$stateParams.cId || null };

                            return dataservice.form.getOptions(options, {isTool:true}, args)
                                .then(function(result){
                                    if(result){
                                        return result;
                                    }else{
                                        logger.error(result.body ? result.body : 'Get combobox options failed', result);
                                        return [];
                                    }
                                });
                        }
                    }
                });
        }]);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/app.config.js
 ** module id = 232
 ** module chunks = 0
 **/